var debounce = debounce || function(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');
      document.body.classList.add('directional-header-enabled');
      this.scroll_header_placeholder = document.querySelector('.scroll-header-placeholder');
      if (!this.scroll_header_placeholder) {
        this.scroll_header_placeholder = document.createElement('div');
        this.scroll_header_placeholder.className = 'scroll-header-placeholder';
        this.scroll_header_placeholder.setAttribute('aria-hidden', 'true');
        this.header_section.parentNode.insertBefore(this.scroll_header_placeholder, this.header_section);
      }

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      this._stickyOffset = 0;
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
        this._stickyOffset = this.offsetTop;
        window.addEventListener('resize', debounce(() => {
          this._stickyOffset = this.offsetTop;
        }, 100), { passive: true });
      }
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Consolidated scroll listener with rAF coalescing
      this._scrollRafId = null;
      this._lastScrollY = window.scrollY;
      this._scrollDirectionDistance = 0;
      this._directionalHeaderActive = false;
      this._naturalHeaderTop = this.header_section.getBoundingClientRect().top + window.scrollY;
      this.mobile_nav_section = document.querySelector('.section-header-mobile-navigation');
      const onScroll = () => {
        if (this._scrollRafId) return;
        this._scrollRafId = requestAnimationFrame(() => {
          this._scrollRafId = null;
          this.updateDirectionalHeader();
          this.setStickyClass();
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });

      this.setHeaderOffset();
      this.setHeaderHeight();
      window.addEventListener('resize', debounce(() => {
        this.setHeaderOffset();
        this.setHeaderHeight();
      }, 100), { passive: true });
      onScroll();

      if (document.querySelector('.announcement-bar-section')) {
        this.setAnnouncementHeight();
        window.addEventListener('resize', debounce(() => {
          this.setAnnouncementHeight();
        }, 100), { passive: true });
      }

      // Mobile Navigation transparent header support.
      setTimeout(() => {

        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);
      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        this.classList.toggle('is-sticky', window.scrollY >= this._stickyOffset && window.scrollY > 0);
      }
    }
    updateDirectionalHeader() {
      // When sticky navigation is disabled, keep the header in normal document
      // flow so it leaves the viewport naturally as the page scrolls.
      if (!this.classList.contains('header-sticky--active')) return;

      if (!this.mobile_nav_section) {
        this.mobile_nav_section = document.querySelector('.section-header-mobile-navigation');
      }
      const currentScrollY = Math.max(window.scrollY, 0);
      const isMobile = window.innerWidth < 768;
      const mobileNavHeight = isMobile && this.mobile_nav_section ? this.mobile_nav_section.offsetHeight : 0;
      const revealOffset = this.header_section.offsetHeight + mobileNavHeight;
      const targets = [this.header_section];

      if (isMobile && this.mobile_nav_section) targets.push(this.mobile_nav_section);

      if (!this._directionalHeaderActive) {
        this._naturalHeaderTop = this.header_section.getBoundingClientRect().top + currentScrollY;
      }

      const activationOffset = this._naturalHeaderTop + revealOffset;

      if (!this._directionalHeaderActive && currentScrollY < activationOffset) {
        targets.forEach((target) => target.classList.remove('scroll-header--ready', 'scroll-header--visible'));
        if (this.mobile_nav_section) this.mobile_nav_section.style.removeProperty('--scroll-header-main-height');
        this.scroll_header_placeholder.style.height = '0px';
        this.scroll_header_placeholder.classList.remove('scroll-header-placeholder--active');
        this._scrollDirectionDistance = 0;
        this._lastScrollY = currentScrollY;
        return;
      }

      if (!this._directionalHeaderActive) {
        this.scroll_header_placeholder.style.height = `${revealOffset}px`;
        this.scroll_header_placeholder.classList.add('scroll-header-placeholder--active');
        targets.forEach((target) => target.classList.add('scroll-header--ready', 'scroll-header--activating'));
        targets.forEach((target) => target.style.setProperty('--scroll-header-total-height', `${revealOffset}px`));
        if (isMobile && this.mobile_nav_section) {
          this.mobile_nav_section.style.setProperty('--scroll-header-main-height', `${this.header_section.offsetHeight}px`);
        }
        this._directionalHeaderActive = true;
        requestAnimationFrame(() => {
          targets.forEach((target) => target.classList.remove('scroll-header--activating'));
        });
        this._scrollDirectionDistance = 0;
        this._lastScrollY = currentScrollY;
        return;
      }

      const returnOffset = Math.max(this._naturalHeaderTop - currentScrollY, 0);
      targets.forEach((target) => {
        target.style.setProperty('--scroll-header-total-height', `${revealOffset}px`);
        target.style.setProperty('--scroll-header-return-offset', `${returnOffset}px`);
      });

      if (currentScrollY <= this._naturalHeaderTop) {
        targets.forEach((target) => target.classList.add('scroll-header--visible'));
        this._scrollDirectionDistance = 0;
        this._lastScrollY = currentScrollY;
        return;
      }

      this.scroll_header_placeholder.style.height = `${revealOffset}px`;
      if (!isMobile && this.mobile_nav_section) {
        this.mobile_nav_section.classList.remove('scroll-header--ready', 'scroll-header--visible', 'scroll-header--activating');
        this.mobile_nav_section.style.removeProperty('--scroll-header-main-height');
        this.mobile_nav_section.style.removeProperty('--scroll-header-total-height');
        this.mobile_nav_section.style.removeProperty('--scroll-header-return-offset');
      }

      const distance = currentScrollY - this._lastScrollY;

      if ((distance > 0 && this._scrollDirectionDistance < 0) || (distance < 0 && this._scrollDirectionDistance > 0)) {
        this._scrollDirectionDistance = 0;
      }
      this._scrollDirectionDistance += distance;

      if (this._scrollDirectionDistance < -4) {
        targets.forEach((target) => target.classList.add('scroll-header--visible'));
        this._scrollDirectionDistance = 0;
      } else if (this._scrollDirectionDistance > 12) {
        targets.forEach((target) => target.classList.remove('scroll-header--visible'));
        this._scrollDirectionDistance = 0;
      }

      this._lastScrollY = currentScrollY;
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.parentElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');
      const parentLinks = this.menu.dataset.parentLinks === 'true';
      const kitchenNavigation = detailsElement.closest('[data-menu-handle="kitchen-equipment"]');
      if (kitchenNavigation) {
        event.preventDefault();
        if (isOpen) return;
        const parentPanel = detailsElement.parentElement.closest('.sub-menu');
        if (parentPanel) {
          detailsElement._returnPanel = parentPanel;
          detailsElement._returnScrollTop = parentPanel.scrollTop;
          parentPanel.scrollTop = 0;
        }
        detailsElement.setAttribute('open', '');
      }

      if (parentLinks && !kitchenNavigation) {
        event.preventDefault();
        const clickedArrow = event.target.closest('.link-forward');

        if (!clickedArrow) {
          const anchor = summaryElement.querySelector('a');
          if (anchor && anchor.href) {
            window.location.href = anchor.href;
            return;
          }
        }

        if (isOpen) {
          detailsElement.removeAttribute('open');
          return;
        }
        detailsElement.setAttribute('open', '');
      }

      // Hydrate deferred sub-menu on first open
      const tpl = detailsElement.querySelector(':scope > .mobile-menu-deferred');
      if (tpl) {
        detailsElement.appendChild(tpl.content);
        tpl.remove();
        detailsElement.querySelectorAll('summary').forEach(s => s.addEventListener('click', this.onSummaryClick.bind(this)));
        detailsElement.querySelectorAll('.parent-link-back--button').forEach(b => b.addEventListener('click', this.onCloseButtonClick.bind(this)));
      }

      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        if (kitchenNavigation) {
          const panel = detailsElement.querySelector(':scope > .sub-menu');
          if (panel) {
            panel.scrollTop = 0;
            panel.querySelector('.parent-link-back--button')?.focus({ preventScroll: true });
          }
        }
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
          const parentDetails = detailsElement.parentElement.closest('.link-container');
          parentDetails?.classList.remove('submenu-open');
          if (detailsElement._returnPanel) {
            detailsElement._returnPanel.scrollTop = detailsElement._returnScrollTop || 0;
          }
          if (detailsElement.closest('[data-menu-handle="kitchen-equipment"]')) {
            detailsElement.querySelector(':scope > summary')?.focus({ preventScroll: true });
          }
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
    }
    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      document.fonts.ready.then(function() {
        window.addEventListener('resize', debounce(function() {
          _this.resizeSubMenus();
        }, 100));
      });

    }
    resizeSubMenus() {
      let updates = [];
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
            total = w + l;
          updates.push({ el: sub_submenu.parentElement, needsLeft: total > window.innerWidth });
        });
      });
      updates.forEach(({ el, needsLeft }) => {
        el.classList.toggle('left-submenu', needsLeft);
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}
